import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellDescription from "ds/components/Table/Row/CellDescription";

const BlueprintsTableDescriptionCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={blueprint.description} />
    </TableSimpleCell>
  );
};

export default BlueprintsTableDescriptionCell;
